import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d9abe92"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "super-centered" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "logotipo mb-4",
    src: "https://i.imgur.com/Cb4nqcG.png",
    alt: "logo"
  })
], -1))
const _hoisted_3 = {
  key: 0,
  class: "box activation-box has-text-centered"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "fa fa-cog fa-spin fa-5x" })
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "has-text-weight-semibold is-size-5" }, " A ativar a sua conta... ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Aguarde um momento por favor", -1))
const _hoisted_7 = { class: "mt-5" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Regressar")
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 0,
  class: "box activation-box has-text-centered"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "fa fa-check-circle has-text-success fa-6x icon-animation" })
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "has-text-weight-semibold is-size-5" }, " Sucesso! ", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "A sua conta foi ativa!", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-4 is-size-7 has-text-weight-semibold" }, [
  /*#__PURE__*/_createTextVNode("Pode começar agora a gerir o seu "),
  /*#__PURE__*/_createElementVNode("strong", null, "Goldylocks"),
  /*#__PURE__*/_createTextVNode(".")
], -1))
const _hoisted_15 = { class: "mt-5" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Abrir área de cliente")
const _hoisted_17 = {
  key: 1,
  class: "box activation-box has-text-centered"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "fa fa-times has-text-danger fa-6x icon-animation" })
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "has-text-weight-semibold is-size-5" }, " Erro! ", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Não foi possivel ativar a sua conta!", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-4 is-size-7 has-text-weight-semibold" }, "Verifique se já se encontra ativa ou poderá ter expirado.", -1))
const _hoisted_22 = { class: "mt-5" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Regressar")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _hoisted_2,
      (_ctx.isActivating)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", null, [
              _hoisted_5,
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_router_link, {
                  class: "is-size-7",
                  to: "/login"
                }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                })
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, [
            (_ctx.isActivated)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("div", null, [
                    _hoisted_12,
                    _hoisted_13,
                    _hoisted_14,
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_component_router_link, {
                        class: "button is-primary",
                        to: "/login"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_16
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _hoisted_18,
                  _createElementVNode("div", null, [
                    _hoisted_19,
                    _hoisted_20,
                    _hoisted_21,
                    _createElementVNode("div", _hoisted_22, [
                      _createVNode(_component_router_link, {
                        class: "button is-primary",
                        to: "/login"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_23
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]))
          ]))
    ])
  ]))
}